// Block J (UI-22): the page frame for My tasks and its views. Inside TasksPage the views are tabs
// (embedded) and TasksPage draws the page header; reached on their own (/week, or Today and
// Tomorrow from the week) each view draws the same header itself.
import React from 'react';
import { useCurrentUser } from '../contexts/CurrentUserContext';
import { personalFlag } from '../nav/views';
import { PageHeader, PageLayout, AddTaskButton } from '../ui';
import './tasks.css';

// The sidebar group Tasks sits in: My work in a business, My stuff in Personal (decision 11); both
// are the yellow group colour.
export function useTasksEyebrow() {
  const { workspaces, activeWorkspaceId } = useCurrentUser() || {};
  return { label: personalFlag(workspaces, activeWorkspaceId) ? 'My stuff' : 'My work', color: 'group-my-work' };
}

export function TasksStandalone({ embedded, title, subline, onAddTask, children }) {
  const eyebrow = useTasksEyebrow();
  if (embedded) return <div className="tk-stack">{children}</div>;
  return (
    <PageLayout data-page="tasks">
      <PageHeader eyebrow={eyebrow} title={title} subline={subline}
        primary={onAddTask ? <AddTaskButton onClick={onAddTask} /> : null} />
      <div className="tk-stack">{children}</div>
    </PageLayout>
  );
}
